export default __webpack_public_path__ + "static/media/2.bddb3225.jpeg";